const hasAnyDemandDownload = (docxFiles = {}) =>
  Object.values(docxFiles || {}).some(
    (file) => Array.isArray(file?.downloads?.userIds) && file.downloads.userIds.length > 0
  ) ||
  (Array.isArray(docxFiles?.downloads?.userIds) && docxFiles.downloads.userIds.length > 0);

export { hasAnyDemandDownload };
